import { createSlice } from '@reduxjs/toolkit'

const initialState = {
    filters:{},
}

const filterSlice = createSlice({
    name: 'filter',
    initialState,
    reducers: {
        setFilterField(state, action) {
            state.filters = {
                ...(state.filters || {}),
                [action.payload.pathname]: action.payload.filters
            }
        },
        removeFilterField(state, action) {
            const updateFilter = {
                ...(state.filters || {}),
            }
            delete updateFilter[action.payload.pathname]

            state.filters = updateFilter
        },
        resetFilterFields(state) {
            state.fields = initialState
        }
    },
})

export const { setFilterField,removeFilterField, resetFilterFields } = filterSlice.actions
export default filterSlice.reducer
